export default __webpack_public_path__ + "static/media/Reserva.e1981167.svg";